import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ApolloProvider } from '@apollo/client';
import appReducer from '../common/reducers';
import client from './graphql/client';

export default function renderEntryPoint({
  router: Router,
  initialState,
  apiMiddleware,
}) {
  const rootNode = document.querySelector('#root');
  const supportsHistory = 'pushState' in window.history;

  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(appReducer, initialState, composeEnhancers(
    applyMiddleware(apiMiddleware),
  ));

  const render = (Component) => {
    ReactDOM.hydrate((
      <HelmetProvider>
        <ApolloProvider client={client}>
          <BrowserRouter forceRefresh={!supportsHistory}>
            <ReduxProvider store={store}>
              <Component />
            </ReduxProvider>
          </BrowserRouter>
        </ApolloProvider>
      </HelmetProvider>
    ), rootNode);
  };

  render(Router);
}
